import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgLetModule } from 'ng-let';
import { InputGroupModule, InputModule, ModalModule, ModalService, SelectModule, TabsModule } from '@msi/cobalt';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { logoutRequest } from '../+state/user.actions';
import { selectLoggedAtDifferentPosition } from '../../configuration/+state/configuration.selectors';
import { UserService } from '../services/user.service';
import { RemoteLogoutConfirmationComponent } from './remote-logout-confirmation/remote-logout-confirmation.component';
import {
    selectRemoteLogoutStatus,
    selectRemoteSessionActiveCall
} from '../+state/user.selectors';
import { debounceTime, filter, tap } from 'rxjs/operators';

@Component({
    templateUrl: './session-logout-component.html',
    styleUrl: './session-logout-component.scss',
    imports: [CommonModule, NgLetModule, ModalModule, TabsModule, InputGroupModule, InputModule, SelectModule, FormsModule]
})
export class SessionLogoutComponent implements OnInit {
    public logoutRequestFailed = false;
    public logoutRequestSuccess: boolean = false;
    public logoutRequestInProgress: boolean;
    public positionNumber: string;
    public positionName: string;
    constructor(
        private store: Store,
        private userService: UserService,
        private modalService: ModalService
    ) {}

    sendLogoutRequest() {
        this.store.dispatch(logoutRequest({forced: false}));
    }

    logoutCurrentSession() {
        this.userService.logout().subscribe();
    }

    ngOnInit(): void {
        this.store.select(selectRemoteLogoutStatus)
            .pipe(
                filter((statuses) => Boolean(statuses.length)),
                tap((statuses) => {
                    // update in progress state to have a smooth transition
                    const inProgress = statuses.some((state) => state.inProgress);
                    if (inProgress) {
                        this.logoutRequestInProgress = true;
                        this.logoutRequestFailed = false;
                    }
                }),
                debounceTime(200))
            .subscribe((statuses) => {
                const inProgress = statuses.some((state) => state.inProgress);
                const onCall = statuses.some((state) => state.onCall);
                const logoutSuccessful= statuses.some((state) => state.logoffSuccessful);
                if (logoutSuccessful && !inProgress && !onCall) {
                    this.logoutRequestSuccess = true;
                    this.logoutRequestInProgress = false;
                    setTimeout(() => window.location.reload(), 5000);
                } else if (!inProgress && !onCall) {
                    this.logoutRequestFailed = true;
                    this.logoutRequestInProgress = false;
                }
        });

        this.store.select(selectLoggedAtDifferentPosition).subscribe((loggedAtDifferentPosition) => {
            if (loggedAtDifferentPosition) {
                this.positionNumber = loggedAtDifferentPosition.positionNumber;
                this.positionName = loggedAtDifferentPosition.positionName;
            }
        });

        this.store.select(selectRemoteSessionActiveCall).pipe(filter((activeCall) => activeCall)).subscribe( () => {
            this.modalService.open(RemoteLogoutConfirmationComponent, {
                hasBackdrop: true,
                disableClose: true,
                minWidth: '25vw',
                data: { parent: this }
            });
        })
    }
}
